module.exports = __webpack_public_path__ + "img/golf_course_2.ff26c15c.jpg";